import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { PaqueteRADEdit } from "./edit";
import { setDescripciones } from "./logic";
const EditModal = PaqueteRADEdit;
type Entity = models.BitacoraRADPaqueteDto;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
    error?: kea.FieldError;
}

export interface BotonesDeps {
    onEdit: (x: Entity) => void;
    onBorrar: (x: Entity) => void;
    onDuplicar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesDeps): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones([...kea.columnaBotonesDefault(deps),
    {
        onClick: deps.onDuplicar,
        iconClass: fa("copy"),
        tooltip: "Duplicar"
    }]);

    return [
        botones,
        { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
        { title: "Peso y volumen", cell: x => ({ data: undefined, view: () => <span style={{ whiteSpace: "nowrap" }} ><i className={fa("balance-scale", "fw")} />{x.Peso} kg <i className={fa("cube", "fw")} />{x.Alto}×{x.Largo}×{x.Ancho} cm</span> }) },
        { title: "Descripción", cell: x => ({ data: x.NombreDescripcionPaquete }) },
        { title: "Contenido", cell: x => ({ data: x.NombreContenidoPaquete }) },

    ];
}

/**
* Listado de PaqueteDocumentacion
*/
class PaqueteRADListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private handleOnAgregar = async () => {
        //Si no puede modificar checkbox de recolección a domicilio siempre debe de ser true
        const result = await this.modals.showModal(EditModal, {  }, {  } as Entity);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, {}, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    private handleOnDuplicar = (x: Entity) => {
        this.props.onChange([... this.props.value, { ...x }]);
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar, onDuplicar: this.handleOnDuplicar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <kea.Title titulo="Paquetes" size="h4" error={this.props.error} onAgregar={this.props.readonly ? undefined : this.handleOnAgregar} iconClass={fa("cubes", "fw")} />
                    </div>
                </div >

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div >
        );
    }
}
export const PaqueteRADList = kea.mapProps(componentToRx(PaqueteRADListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/edit/paquetes/list.tsx